/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListExecutionGroupRequest {
    getFixupPrototypeFunction() { return AwsSsmListExecutionGroupRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListExecutionGroupRequest>): AwsSsmListExecutionGroupRequest {
        let obj = Object.assign(new AwsSsmListExecutionGroupRequest(), model);
        AwsSsmListExecutionGroupRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListExecutionGroupRequest>): AwsSsmListExecutionGroupRequest {
        if (!model) return null;
        return AwsSsmListExecutionGroupRequest.newInstance(<AwsSsmListExecutionGroupRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListExecutionGroupRequest) {
        if (!obj) return;

        models.AwsSsmListExecutionGroupRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListExecutionGroupRequest): boolean {
        Object.setPrototypeOf(obj, AwsSsmListExecutionGroupRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AwsSsmExecutionGroupFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AwsSsmListDocumentExecutionGroupsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AwsSsmListDocumentExecutionGroupsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AwsSsmExecutionGroupFilters;

}
